const stats = [
  { value: '12,680+', label: '累计爆料条目' },
  { value: '365天', label: '全年无休更新' },
  { value: '890万+', label: '月活跃吃瓜用户' },
];

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-background-100"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-semibold tracking-wider uppercase bg-primary-100 text-primary-700 rounded-full mb-4">
              全网黑料吃瓜第一站
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-3">
              每日黑料网
              <span className="block text-primary-600 mt-1 text-xl md:text-3xl lg:text-4xl">
                全网热门爆料 · 核心入口导航
              </span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-foreground-500 font-heading font-semibold italic mb-5">
              每天三分钟，瓜田不迷路
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-6">
              每日黑料网汇集全网最新最热的娱乐圈内幕、社会争议事件、网红塌房实录与各类独家爆料，
              是中文互联网最全面的黑料吃瓜内容聚合导航平台。
              每日实时更新，覆盖微博热搜、豆瓣八卦、抖音快讯等多渠道信源，
              让你一站式掌握全网最劲爆的瓜。当前热门话题涵盖顶流恋情实锤、综艺幕后争议、
              直播圈互撕内幕等多个焦点领域。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-lg md:text-xl font-heading font-bold text-primary-600">
                    {s.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-flashlight-line text-lg"></i>
                查看最新爆料
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-800 font-medium text-sm rounded-lg border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-price-tag-3-line text-lg"></i>
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20bold%20editorial%20dark%20themed%20visual%20representing%20entertainment%20gossip%20and%20scandal%20news%2C%20abstract%20newspaper%20clippings%20collage%20style%2C%20warm%20crimson%20red%20accents%20on%20charcoal%20dark%20background%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20stylized%20editorial%20magazine%20composition%2C%20subtle%20grunge%20texture%2C%20cinematic%20atmosphere%2C%20mysterious%20and%20intriguing%20mood%2C%20no%20text%20no%20people%20faces&width=700&height=500&seq=hero-main-visual&orientation=landscape"
                alt="每日黑料 - 全网黑料吃瓜内容核心入口主视觉"
                onError={(e) => { const el = (e.currentTarget as HTMLElement); if (el.parentElement) el.parentElement.style.display = 'none'; }}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}